<template>
	<draggable
		v-model="internalItems"
		tag="tbody"
		item-key="id"
		class="list-group"
		ghost-class="ghost"			
		@end="onDragEnd">
		<template #item="{ element, index }">
			<tr :class="rowClassProcessorInvoker(element, index)">
				<slot name="item" v-bind="{ element, index }">
					<td class="list-group-item">
						element '{{ element }}', index: {{ index }}
					</td>
				</slot>
			</tr>
		</template>
	</draggable>
</template>

<script setup lang="ts">
import { ref, watch, defineProps, defineEmits } from 'vue';
import draggable from 'vuedraggable';

/* eslint-disable */ 
const props = defineProps<{
	items: Array<any>;
	rowClassProcessor?: (item: any, itemIndex: number) => any
}>();

/* eslint-disable */
const emit = defineEmits<{
  (e: 'update:items', value: typeof props.items): void;
  (e: 'reordered', newOrder: typeof props.items): void;
}>();

const internalItems = ref([...props.items]);

watch(
	() => props.items, 
	(newVal) => internalItems.value = [...newVal], { deep: true }
);

const onDragEnd = () => {
	const _tems = [...internalItems.value];
  emit('update:items', _tems);
  emit('reordered', _tems);
};

const rowClassProcessorInvoker = (item: any, itemIndex: number) => {
	if (typeof props.rowClassProcessor === 'function') {
		return props.rowClassProcessor(item, itemIndex);
	}	
}
</script>

<style scoped>
.r {
	color: red;
}
.container {
	max-width: 500px;
	margin: 0 auto;
	padding: 20px;
}

.list-group {
	min-height: 20px;
	padding: 0;
}

.list-group-item {
	cursor: move;
	padding: 10px 15px;
	margin: 5px 0;
	background: #747474;
	border: 1px solid #dee2e6;
	border-radius: 4px;
}

.list-group-item:hover {
	background: #e9ecef;
}

.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

.debug {
	margin-top: 20px;
	padding: 10px;
	background: #f5f5f5;
	border-radius: 4px;
}
</style>